import { render, staticRenderFns } from "./advertisement-cover-list.vue?vue&type=template&id=eadbd74a&scoped=true&"
import script from "./advertisement-cover-list.vue?vue&type=script&lang=js&"
export * from "./advertisement-cover-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadbd74a",
  null
  
)

export default component.exports